const timeoutConfig = {
  idleTimeout: 30 * 60 * 1000, // 30min
  warningTime: 2 * 60 * 1000, // 2min
  enableMultiTabSync: true,
  sessionCheckInterval: 30000, // 30second
};

/**
 * session config file
 * used to configure user session related parameters
 */

interface SessionConfig {
  // idle timeout time (milliseconds)
  idleTimeout: number;
  // warning time (milliseconds)
  warningTime: number;
  // whether to enable multi-tab synchronization
  enableMultiTabSync: boolean;
  // session check interval (milliseconds) - used for SessionMonitor
  sessionCheckInterval: number;
}

// config of production environment
const productionConfig: SessionConfig = {
  idleTimeout: timeoutConfig.idleTimeout, // 30min
  warningTime: timeoutConfig.warningTime, // 2min
  enableMultiTabSync: true,
  sessionCheckInterval: 30000, // 30second
};

// config of test environment (for quick testing)
const testConfig: SessionConfig = {
  idleTimeout: 30 * 1000, // 30second
  warningTime: 10 * 1000, // 10second
  enableMultiTabSync: true,
  sessionCheckInterval: 10000, // 10second
};

/**
 * get config based on environment
 */
export const getSessionConfig = (): SessionConfig => {
  const isProduction = import.meta.env.PROD;
  // const isDevelopment = import.meta.env.DEV;

  // if (isProduction) {
  //   return productionConfig;
  // } else {
  //   return testConfig;
  // }

  return productionConfig;
};

/**
 * default export current environment config
 */
const sessionConfig = getSessionConfig();

export default sessionConfig;

/**
 * convert milliseconds to readable time string
 */
export const formatTimeout = (ms: number): string => {
  const minutes = Math.floor(ms / 60000);
  const seconds = Math.floor((ms % 60000) / 1000);

  if (minutes > 0 && seconds > 0) {
    return `${minutes}m${seconds}s`;
  } else if (minutes > 0) {
    return `${minutes}m`;
  } else {
    return `${seconds}s`;
  }
};
